export default "__VITE_ASSET__BEB5$VOM__"